import React from 'react';
import './SupportPage.css';

const PrivacyPolicy = () => {
  return (
    <div className="support-page">
      <div className="support-header">
        <h1 className="support-title">Privacy Policy</h1>
        <p className="support-subtitle">
          Your privacy is important to us. This policy explains how we collect, use, and protect your information.
        </p>
      </div>
      
      <div className="support-content">
        <div className="info-box">
          <p>
            <strong>Last Updated:</strong> January 2025
          </p>
        </div>
        
        <h2>1. Information We Collect</h2>
        <h3>Information You Provide</h3>
        <ul>
          <li>Account registration information (name, email address)</li>
          <li>Contact form submissions and support requests</li>
          <li>Newsletter subscription preferences</li>
          <li>User preferences and settings</li>
        </ul>
        
        <h3>Information We Collect Automatically</h3>
        <ul>
          <li>Device information (browser type, operating system)</li>
          <li>Usage data (pages visited, time spent, clicks)</li>
          <li>IP address and location data</li>
          <li>Cookies and similar tracking technologies</li>
        </ul>
        
        <h2>2. How We Use Your Information</h2>
        <p>We use the information we collect to:</p>
        <ul>
          <li>Provide and improve our football news and scores service</li>
          <li>Personalize your experience and content recommendations</li>
          <li>Send you updates, newsletters, and important announcements</li>
          <li>Respond to your questions and provide customer support</li>
          <li>Analyze usage patterns to improve our platform</li>
          <li>Ensure the security and integrity of our service</li>
          <li>Comply with legal obligations</li>
        </ul>
        
        <h2>3. Information Sharing</h2>
        <p>We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:</p>
        <ul>
          <li><strong>Service Providers:</strong> With trusted third-party service providers who help us operate our platform</li>
          <li><strong>Legal Requirements:</strong> When required by law or to protect our rights and the safety of our users</li>
          <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of our business</li>
          <li><strong>Consent:</strong> When you explicitly consent to sharing your information</li>
        </ul>
        
        <h2>4. Cookies and Tracking</h2>
        <p>We use cookies and similar technologies to:</p>
        <ul>
          <li>Remember your preferences and settings</li>
          <li>Analyze website traffic and usage patterns</li>
          <li>Provide personalized content and advertisements</li>
          <li>Improve website functionality and user experience</li>
        </ul>
        <p>You can control cookies through your browser settings, but disabling cookies may affect some features of our service.</p>
        
        <h2>5. Data Security</h2>
        <p>
          We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, 
          alteration, disclosure, or destruction. These measures include:
        </p>
        <ul>
          <li>Encryption of data in transit and at rest</li>
          <li>Regular security assessments and updates</li>
          <li>Access controls and authentication requirements</li>
          <li>Employee training on data protection practices</li>
        </ul>
        
        <h2>6. Data Retention</h2>
        <p>
          We retain your personal information only for as long as necessary to provide our services and fulfill the purposes outlined in this policy. 
          When we no longer need your information, we will securely delete or anonymize it.
        </p>
        
        <h2>7. Your Rights</h2>
        <p>Depending on your location, you may have the following rights regarding your personal information:</p>
        <ul>
          <li><strong>Access:</strong> Request a copy of the personal information we hold about you</li>
          <li><strong>Correction:</strong> Request correction of inaccurate or incomplete information</li>
          <li><strong>Deletion:</strong> Request deletion of your personal information</li>
          <li><strong>Portability:</strong> Request transfer of your data in a machine-readable format</li>
          <li><strong>Objection:</strong> Object to processing of your personal information</li>
          <li><strong>Restriction:</strong> Request restriction of processing in certain circumstances</li>
        </ul>
        
        <h2>8. Third-Party Links</h2>
        <p>
          Our service may contain links to third-party websites or services. We are not responsible for the privacy practices 
          of these external sites. We encourage you to review their privacy policies before providing any information.
        </p>
        
        <h2>9. Children's Privacy</h2>
        <p>
          Our service is not intended for children under 13 years of age. We do not knowingly collect personal information 
          from children under 13. If we become aware that we have collected such information, we will delete it promptly.
        </p>
        
        <h2>10. International Data Transfers</h2>
        <p>
          Your information may be transferred to and processed in countries other than your country of residence. 
          We ensure appropriate safeguards are in place to protect your information during such transfers.
        </p>
        
        <h2>11. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. We will notify you of any material changes by posting 
          the new policy on this page and updating the "Last Updated" date. Your continued use of our service after 
          such changes constitutes acceptance of the updated policy.
        </p>
        
        <h2>12. Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy or our privacy practices, please contact us:
        </p>
        <ul>
          <li>Email: <a href="mailto:privacy@vfootball.com">privacy@vfootball.com</a></li>
          <li>Contact Form: <a href="/contact">Contact Us</a></li>
        </ul>
        
        <div className="info-box">
          <p>
            <strong>Your Privacy Matters:</strong> We are committed to protecting your privacy and maintaining your trust. 
            If you have any concerns about how we handle your information, please don't hesitate to reach out to us.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;